"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noopTelemetry = exports.NoopTelemetry = void 0;
/**
 * The disabled telemetry client: every method is a no-op. This is the default
 * everywhere consent is absent, unknown, or resolution failed — so `app`
 * use-cases can call `deps.telemetry.track(...)` unconditionally with zero
 * branching and zero risk of network I/O.
 */
class NoopTelemetry {
    track() {
        /* intentionally empty */
    }
    async flush() {
        /* intentionally empty */
    }
}
exports.NoopTelemetry = NoopTelemetry;
/** Shared singleton — the Noop client holds no state, so one instance is enough. */
exports.noopTelemetry = new NoopTelemetry();
